import { Api, DisplayType, McLeodClassicIntegration } from "@mcleod/core";
import {
    Button, ChangeEvent, ClickEvent, DataSourceExecutionEvent, DataSourceMode, DropdownSelectionEvent,
    LookupModelSelectionEvent, TableRowDisplayEvent, TableRowMode, Textbox, Toast, ValidationResult
} from "@mcleod/components";
import { AutogenLayoutPnnControlsTransmit } from "./autogen/AutogenLayoutPnnControlsTransmit";

const CONTACT_EMAIL = "E";

export class PnnControlsTransmit extends AutogenLayoutPnnControlsTransmit {

    tableRevenueCodesOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const textboxRevenueCode = tableRow.findComponentById("textboxRevenueCodeId") as Textbox;
        const textboxRevenueCodeDescr = tableRow.findComponentById("textboxRevenueCodeDescr") as Textbox;
        const textboxRevenueCodeDescrQuick = tableRow.findComponentById("textboxRevenueCodeDescrQuick") as Textbox;
        if (textboxRevenueCode != null && textboxRevenueCodeDescr != null && textboxRevenueCodeDescrQuick != null) {
            textboxRevenueCode.addlValidationCallback = (_value: string, mode: DataSourceMode): ValidationResult => {
                if (mode === DataSourceMode.SEARCH) {
                    return null;
                }
                const result: ValidationResult = {
                    isValid: true,
                    component: textboxRevenueCode
                };
                this.sourcePnnRevcode.data.forEach((row) => {
                    if (row.get("revenue_code_id") == textboxRevenueCode.text) {
                        result.isValid = false;
                        result.validationMessage = 'You may not add duplicate revenue codes to the table.';
                    }
                })
                return result;
            };
            if (tableRow.mode == TableRowMode.QUICK_ADD) {
                textboxRevenueCode.addLookupModelSelectionListener((event: LookupModelSelectionEvent) => {
                    if (event.hasSelection() !== true)
                        return;
                    textboxRevenueCodeDescr.visible = false;
                    textboxRevenueCodeDescrQuick.text = event.selection.get("descr");
                });
            }
            else {
                textboxRevenueCodeDescrQuick.visible = false;
            }
        }
    }

    tableLoadSchedulesOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const textboxTimeCode = tableRow.findComponentById("textboxTimeCode") as Textbox;
        if (textboxTimeCode != null) {
            textboxTimeCode.addlValidationCallback = (_value: string, mode: DataSourceMode): ValidationResult => {
                if (mode === DataSourceMode.SEARCH) {
                    return null;
                }
                const result: ValidationResult = {
                    isValid: true,
                    component: textboxTimeCode
                };
                this.sourcePnnLoadSched.data.forEach((row) => {
                    if (row.get("time_descr") == textboxTimeCode.text) {
                        result.isValid = false;
                        result.validationMessage = 'You may not add duplicate time code to the table.';
                    }
                })
                return result;
            };
        }
    }

    buttonOpenClassicOnClick(event: ClickEvent) {
        McLeodClassicIntegration.openClassicScreen("com.tms.client.loadmaster.general.EntryEmailControl", this.mainDataSource.activeRow.get("id"));
    }

    sourcePnnControlAfterExecution(event: DataSourceExecutionEvent) {
        if (this.mainDataSource.activeRow.getBoolean("all_revenue_codes", false)) {
            this.tableRevenueCodes.visible = false;
        }
        if (this.mainDataSource.activeRow.get("reply_via") == CONTACT_EMAIL) {
            this.textboxAt.displayType = DisplayType.EMAIL;
        }
        else {
            this.textboxAt.displayType = DisplayType.PHONE;
        }
        if (this.mainDataSource.activeRow.get("unsubscribe_contact_method") == CONTACT_EMAIL) {
            this.textboxAtUnsubscribe.displayType = DisplayType.EMAIL;
        }
        else {
            this.textboxAtUnsubscribe.displayType = DisplayType.PHONE;
        }
    }

    switchAllRevenueCodeOnChange(event: ChangeEvent) {
        this.tableRevenueCodes.visible = !event.newValue;
    }

    textboxViaAfterDropdownSelection(event: DropdownSelectionEvent) {
        this.setDisplayTypeBasedOnSelection(event.selection.value, this.textboxAt);
    }

    textboxViaContactAfterDropdownSelection(event: DropdownSelectionEvent) {
        this.setDisplayTypeBasedOnSelection(event.selection.value, this.textboxAtUnsubscribe);
    }

    setDisplayTypeBasedOnSelection(selectionValue: string, textbox: any): void {
        textbox.displayType = (selectionValue === CONTACT_EMAIL) ? DisplayType.EMAIL : DisplayType.PHONE;
    }

    buttonSendAvailableEmailOnClick(event: ClickEvent) {
        const btn = event.target as Button;
        btn.busy = true;
        Api.post('lme/dispatch/pnn/transmit')
        .then(_ => Toast.showSuccessToast('Orders transmitted to Carriers.'))
        .finally(() => btn.busy = false);
    }
}
